import type { AdminSubmission } from '../lib/types.ts';
import { documentRowData } from './documentRow.ts';
import { expiryState } from '../lib/expiry.ts';

export type ComplianceStats = { current: number; expiringSoon: number; expired: number };

// Tally a company's compliance-document rows by expiry health. Pure; `now` is
// injectable for tests. Reuses documentRowData + expiryState so the buckets
// match the per-row expiry chips in DocumentReviewTable:
//   awaiting (nothing provided) → not counted
//   adopted library doc         → current
//   uploaded file               → expired / expiringSoon / current (ok|none)
export function complianceDocStats(
  submissions: (AdminSubmission | undefined)[],
  now: Date = new Date(),
): ComplianceStats {
  const stats: ComplianceStats = { current: 0, expiringSoon: 0, expired: 0 };
  for (const submission of submissions) {
    const row = documentRowData(submission);
    if (row.kind === 'awaiting') continue;
    if (row.kind === 'adopted') {
      stats.current += 1;
      continue;
    }
    switch (expiryState({ expires_at: row.expiresAt }, now)) {
      case 'expired':
        stats.expired += 1;
        break;
      case 'expiring':
        stats.expiringSoon += 1;
        break;
      default: // 'ok' | 'none' — provided and valid
        stats.current += 1;
    }
  }
  return stats;
}
